<template>
  <SignInSignUpLayout>
    <div class="wrapper">
      <h1 class="sign-in-title">{{ title }}</h1>
      <div class="text text-center">
        <slot></slot>
      </div>
      <slot name="button"></slot>
    </div>
  </SignInSignUpLayout>
</template>

<script>
import SignInSignUpLayout from '@components/sign-up/SignInSignUpLayout.vue'

export default {
  name: 'LinkExpired',
  components: { SignInSignUpLayout },
  props: {
    title: {
      type: String,
      required: true,
      default: 'Link expired'
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: $sign-in-form-width;
}

.text {
  text-align: center;
  line-height: 18.38px;
}
</style>
